import { Subscription } from 'rxjs';
import { mainUrl, registerUrl } from './../../../global-variables';
import { RouteAnimationShared } from './../../../utils/route-animation-shared';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UserApiService } from 'src/app/data/repository/user-repository/user-api.service';
import { TextHelper } from 'src/app/utils/text-helper';
import { SubmitButtonShared } from '../../general/shared/submit-button-shared';
import { activationCodeUrl } from 'src/app/global-variables';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { AuthenticationAnalyticsService } from 'src/app/data/repository/analytics-repository/authentication-analytics.service';
import { SocialAuthService } from 'angularx-social-login';
import { GoogleLoginProvider } from 'angularx-social-login';

@Component({
  selector: 'app-phone-register',
  templateUrl: './phone-register.component.html',
  styleUrls: ['./phone-register.component.scss'],
})
export class PhoneRegisterComponent implements OnInit, OnDestroy {
  hasError = false;
  errorMessage: string;
  buttonTitle = 'ورود';
  isActive = false;
  isFocuse = false;
  phoneNumber = '';
  isDone = false;
  showLoading = false;
  googleDone = false;
  returnUrl: string;
  subscription1: Subscription;

  top: number;
  constructor(
    private submitButtonShared: SubmitButtonShared,
    private route: ActivatedRoute,
    private router: Router,
    private userApiService: UserApiService,
    private textHelper: TextHelper,
    private snackBarService: SnackBarService,
    private authAnalytics: AuthenticationAnalyticsService,
    private routeAnimationShared: RouteAnimationShared,
    private authService: SocialAuthService
  ) {
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');

    this.phoneNumber = this.route.snapshot.paramMap.get('phoneNumber');
    this.top = window.innerHeight - 72;
  }

  ngOnInit() {
    this.authAnalytics.analyticAuthenticationVerifyStarted();
    this.submitButtonShared.activateNextButton(false);
    this.submitButtonShared.animateUpButton();
    if (this.phoneNumber !== null) {
      this.activate();
    }
    this.subscription1 = this.authService.authState.subscribe((userData) => {
      this.showLoading = true;
      if (userData.idToken) {
        this.userApiService.googleAuth(userData.idToken).then((res) => {
          if (res.isSuccess) {
            this.isDone = true;
            this.googleDone = true;

            if (res.getData().getType() === 'login') {
              this.routeAnimationShared.showRouteAnimation();
              const url = this.textHelper.replaceDeeplinkToCorrectUrls(
                this.returnUrl
              );
              if (url) {
                this.router.navigate([url]);
              } else {
                this.router.navigate([mainUrl], { replaceUrl: true });
              }
              if (!localStorage.getItem('no-need-intro')) {
                localStorage.setItem('no-need-intro', '1');
              }
            } else if (res.getData().getType() === 'register') {
              this.routeAnimationShared.showRouteAnimation();
              if (this.returnUrl) {
                this.router.navigate([registerUrl + '/' + 'google'], {
                  queryParams: { returnUrl: this.returnUrl },
                });
              } else {
                this.router.navigate([registerUrl + '/' + 'google']);
              }
            }
          }
        });
      }
      this.showLoading = false;
    });
  }

  activate() {
    this.hasError = false;
    if (this.phoneNumber.length === 11) {
      this.isActive = true;
    } else {
      this.isActive = false;
    }
  }
  onFocus() {
    this.isFocuse = true;
    this.hasError = false;
  }
  onBlur() {
    this.isFocuse = false;
  }
  goTerms() {
    this.routeAnimationShared.showRouteAnimation();

    this.router.navigate(['/termsofuse']);
  }
  hasErrors() {
    if (
      this.phoneNumber.length !== 11 ||
      (!this.phoneNumber.startsWith('09') && !this.phoneNumber.startsWith('۰۹'))
    ) {
      return true;
    }
    return false;
  }
  clearInput() {
    this.phoneNumber = '';
  }
  resumeClick() {
    if (this.isActive) {
      if (this.hasErrors()) {
        this.errorMessage = 'شماره وارد شده اشتباه است!';
        this.hasError = true;
        this.isActive = false;
      } else {
        this.showLoading = true;
        const phoneNumber = this.textHelper.replacePersian(this.phoneNumber);

        this.userApiService.sendSMS(phoneNumber).then((res) => {
          if (res.isSuccess()) {
            this.isDone = true;
            setTimeout(() => {
              this.sendSms(phoneNumber);
              this.showLoading = false;
            }, 850);
          } else {
            if (res.getData() && res.getData().getMessage()) {
              this.snackBarService.showSnackBar(res.getData().getMessage());
              this.routeAnimationShared.showRouteAnimation();
              if (this.returnUrl) {
                this.router.navigate([activationCodeUrl + '/' + phoneNumber], {
                  queryParams: { returnUrl: this.returnUrl },
                });
              } else {
                this.router.navigate([activationCodeUrl + '/' + phoneNumber]);
              }
            } else {
              this.hasError = true;
              this.errorMessage = 'خطا در برقراری ارتباط با سرور';
            }
            this.showLoading = false;
          }
        });
      }
    }
  }

  googleAuth() {
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }
  @HostListener('window:beforeunload')
  ngOnDestroy() {
    this.subscription1.unsubscribe();
  }
  sendSms(phoneNumber: string) {
    this.routeAnimationShared.showRouteAnimation();
    if (this.returnUrl) {
      this.router.navigate([activationCodeUrl + '/' + phoneNumber], {
        queryParams: { returnUrl: this.returnUrl },
      });
    } else {
      this.router.navigate([activationCodeUrl + '/' + phoneNumber]);
    }
  }
}
